

const PreviewPushExpanded = (props) => {

  return (
    <>
      <div className="push-background expanded">
        <img className="iphone-mock" src="./images/iphone.png" alt="" />
        <div className="push-container">
          <div className="push-header">
            <img src="./images/apple-touch-icon-120x120.png" className="icon" alt="" />
            <p className="name">NEXIPAY</p>
            <p className="time">adesso</p>
          </div>
          <div className="push-content">
            <div className="push-copy">
              <p className="push-title">{props.value.titlePush}</p>
              <p className="push-text">{props.value.textPush}</p>
             
            </div>
            {props.value.imagePush && (
              <div className="push-image-wrapper">
                 <img src={props.value.imagePush} className="push-image" alt="" />
              </div>
              )}
          </div> 
        </div>
      </div>
    </>
  )
};

export default PreviewPushExpanded;
